export default "/weETH-WETH-BPT.e49e8907c03151713ec81ddab6564440.png";